export default {
  title: "Welcome at Stickyweb!",
  text: "Set your password trough the form below",

  input: {
    password: "Password",
    passwordRepeat: "Repeat password",
  },

  button: {
    save: "Finish registration",
  },

  tokenError: {
    title: "Error",
    intro: "Something went wrong with the registration link, please consider the following options:",
    text: {
      registered: "It can be that you've already used this email to register, try to login or request a new password",
      contact: "Otherwise please contact us and we will help you out.",
      copied: "If you copied the link, make sure you have copied it correctly."
    },
  },

  api: {
    success: {
      accountCreated: "Your password is set, enjoy Stickyweb!",
    },
    error: {
      token: {
        invalid: "Our apologies, but this token is invalid",
      },
      passwords: {
        equal: "The password and repeated password are not equal",
      }
    },
  },

  validate: {
    require: "Fill your password",
  }
}
